export class GroupeVarietalRecolte {
    static jsonMap = {
        idGroupeVarietal: 'idGroupeVarietal'
    };

    idGroupeVarietal: number;
}
